import { Injectable } from '@angular/core';
import { DbService } from '../db/db.service';
import { Project } from 'src/app/models/firebase/project';

@Injectable({
    providedIn: 'root',
})
export class ProjectService {
    constructor(private db: DbService) {}

    async getProjectByURL(url: string) {
        const project = await this.db.firestore.collection(Project.PATH).where('landing_url', '==', url).get();
        if (project.empty) {
            return null;
        }
        return new Project(project.docs[0].data());
    }

    async getProjectById(id: string) {
        const project = await this.db.firestore.collection(Project.PATH).doc(id).get();
        if (!project.exists) {
            return null;
        }
        return new Project(project.data());
    }
}
